var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.02344 14.1392C5.18559 6.99928 11.817 1.80298 19.6629 1.80298C29.2634 1.80298 37.0463 9.58587 37.0463 19.1863C37.0463 28.7868 29.2634 36.5697 19.6629 36.5697C11.9431 36.5697 5.39781 31.5373 3.1306 24.5738",
    stroke: "url(#paint0_linear_569_1466)",
    strokeWidth: 2.53536,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3721 16.1774C25.9855 15.8139 25.4728 15.6311 24.8362 15.6311C24.1995 15.6311 23.6532 15.8139 23.2665 16.1774C22.8799 16.5409 22.6866 17.0305 22.6866 17.6462V23.7061C22.6866 25.3744 21.8987 27.0197 20.0832 27.2424C17.9169 27.5072 16.7759 25.6287 16.7759 23.7061V17.6462C16.7759 17.0305 16.5826 16.543 16.196 16.1774C15.8093 15.8139 15.2861 15.6311 14.6264 15.6311C13.9666 15.6311 13.477 15.8139 13.0904 16.1774C12.7037 16.5409 12.5104 17.0305 12.5104 17.6462V23.8868C12.5104 28.4758 15.6349 31.1885 19.7197 31.2011C19.7239 31.2011 19.7281 31.2011 19.7323 31.2011C19.7365 31.2011 19.7407 31.2011 19.7449 31.2011C23.8297 31.1906 26.9542 28.4758 26.9542 23.8868V17.6462C26.9542 17.0305 26.7609 16.543 26.3742 16.1774H26.3721Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6137 13.3639C15.7103 13.3639 16.5993 12.4749 16.5993 11.3782C16.5993 10.2816 15.7103 9.39258 14.6137 9.39258C13.5171 9.39258 12.6281 10.2816 12.6281 11.3782C12.6281 12.4749 13.5171 13.3639 14.6137 13.3639Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6701 13.3094C25.7667 13.3094 26.6557 12.4204 26.6557 11.3238C26.6557 10.2271 25.7667 9.33813 24.6701 9.33813C23.5735 9.33813 22.6844 10.2271 22.6844 11.3238C22.6844 12.4204 23.5735 13.3094 24.6701 13.3094Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_569_1466",
    x1: 20.0349,
    y1: 0.54225,
    x2: 20.0349,
    y2: 37.8304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2EAD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#B7E6D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9DDCD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#71CCCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#4FC0CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#5CC7AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7ED957"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.929ae4b47e7b319f436cb423301cd3ce.svg";
export { ForwardRef as ReactComponent };